import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { VendorDetailedDto, VendorsClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
import { SortConfig } from '@unity/utils/types';

@Component({
  selector: 'unity-grid-vendor-shared',
  standalone: true,
  imports: [KENDO_GRID, GridSharedComponent, LinkGridcellSharedComponent, ChipWorkflowStateSharedComponent, TypedDirective],
  templateUrl: './grid-vendor-shared.component.html',
  styleUrl: './grid-vendor-shared.component.scss',
})
export class GridVendorSharedComponent extends AbstractGridComponent<VendorDetailedDto> {
  private readonly vendorsClient = inject(VendorsClient);

  protected resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      return query ? { query } : undefined;
    },
    stream: ({ params: { query } }) => this.vendorsClient.getAllAsDetailed(query.page, query.pageSize, query.orderBy, query.filter),
  });

  protected defaultSort: SortConfig[] = [
    {
      field: 'created_dt',
      dir: 'desc',
    },
  ];
}
